import React, { useState } from 'react';
import { Row, Col, Tab, Nav } from 'react-bootstrap';
import { LinkBtn } from '../../components';
import TableIndividual from './DataTables/IndividualTable';

function Index() {
  const [key, setKey] = useState('individual');

  return (
    <>
      <Row className="m-top mb-4">
        <Col>
          <h2 className="m-top mt-1 mb-1">Simulador de Finiquitos</h2>
        </Col>
        <Col md={2} xl={2} lg={2} xs={12}>
          <LinkBtn
            variant="primary"
            block
            to={key === 'individual' ? `/settlement_simulator/new` : `/settlement_simulator/group/new`}
            onClick={() => localStorage.removeItem('settlementForm')}
          >
            Nuevo
          </LinkBtn>
        </Col>
      </Row>
      <Row>
        <Col>
          <Tab.Container id="simulator" activeKey={key} onSelect={k => setKey(k)}>
            <Nav variant="pills" className="ab-pills pt-2">
              <Nav.Item>
                <Nav.Link
                  eventKey="individual"
                  style={{
                    textTransform: 'capitalize'
                  }}
                >
                  Individual
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content>
              <Tab.Pane eventKey="individual">
                <Row style={{ paddingTop: 20, paddingBottom: 20 }}>
                  <Col>
                    <TableIndividual />
                  </Col>
                </Row>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Col>
      </Row>
    </>
  );
}

export default Index;
